import { cx } from 'cva';
import React from 'react';
import ActionBar from './ActionBar';
import NonProfitCauses from './NonProfitCauses';
import NonProfitProfileBar from './NonProfitProfileBar';
import PostAuthorProfile from './PostAuthorProfile';
import PostMessage from './PostMessage';
import PostVideo from './PostVideo';
import ReactionBar from './ReactionBar';
import TrackPostVisibility from '../TrackPost/trackPostVisibility';
import { shouldDisablePostCauses } from '@/utils/post.helper';
import PostImageLink from './PostImageLink';
import { ProfileTypes } from '@/constants/profileType.constant';

function UserPostBody(props) {
  const { post, type, home, orgSlug = null } = props;
  const { sourcePostData } = post;
  const { nonProfit } = post.renderProps;
  const { type: profileType, companyId } = post.author;
  const message = sourcePostData.message;
  const hasMessage = message && message.trim().length > 0;
  const hasVideo = post.renderProps.videoUrls && post.renderProps.videoUrls[0];
  const disablePostCauses = shouldDisablePostCauses(home, orgSlug);
  const isNonProfitProfileBarHidden =
    profileType === ProfileTypes.Organization &&
    companyId === nonProfit?.company_id;

  return (
    <TrackPostVisibility post={post} type={type}>
      <div className="flex flex-col">
        <div className="flex flex-col gap-4 p-6 lg:p-4">
          {!disablePostCauses && nonProfit && nonProfit.causes && (
            <NonProfitCauses nonProfit={nonProfit} className="border-b pb-4" />
          )}
          <PostAuthorProfile
            post={post}
            home={home}
            orgSlug={orgSlug}
            className="border-b pb-4"
          />

          {hasMessage && <PostMessage message={message} />}
        </div>

        {hasVideo ? <PostVideo post={post} /> : <PostImageLink post={post} />}

        {!isNonProfitProfileBarHidden && nonProfit && (
          <NonProfitProfileBar nonProfit={nonProfit} post={post} />
        )}

        <div className="flex flex-col px-6 lg:px-4">
          <ReactionBar
            post={post}
            className={cx('mt-4 border-b', !nonProfit && 'border-t')}
          />

          <div className="flex justify-center py-2">
            <ActionBar post={post} orgSlug={orgSlug} />
          </div>
        </div>
      </div>
    </TrackPostVisibility>
  );
}

export default UserPostBody;
